import { NativeModules } from "react-native"

const scriptURL = NativeModules.SourceCode?.scriptURL || 'http://localhost:3000'
const devIP = () => (__DEV__ ? scriptURL.split('://')[1].split(':')[0] : 'localhost')

export default devIP
